export default __webpack_public_path__ + "static/media/icon_category-groom.2ee5d26c.svg";